import { PrizeDTO } from '@/dto/prizeDTO';
import { UserPrizeDTO } from '@/dto/userPrizeDTO';
import { Prize } from '@/model/prize';
import { UserPrize } from '@/model/userPrize';
import * as DateUtils from '@/utils/dateUtils';
import { Score } from '@/model/score';
import { ScoreDTO } from '@/dto/scoreDTO';

export function getPrizeModel(prizeDTO: PrizeDTO): Prize {
    const prize = new Prize();
    prize.id = prizeDTO.id;
    prize.title = prizeDTO.title;
    prize.description = prizeDTO.description;
    prize.value = prizeDTO.value;
    prize.details = prizeDTO.details;
    prize.ordBy = prizeDTO.ordBy;
    prize.imageUrl = prizeDTO.imageUrl;
    prize.startDate = DateUtils.arrayToDate(prizeDTO.startDate);
    if (prizeDTO.endDate) {
        prize.endDate = DateUtils.arrayToDate(prizeDTO.endDate);
    }
    return prize;
}

export function getPrizeDTO(prize: Prize): PrizeDTO {
    const prizeDTO = new PrizeDTO();
    prizeDTO.id = prize.id;
    prizeDTO.title =  prize.title;
    prizeDTO.description = prize.description;
    prizeDTO.value = prize.value;
    prizeDTO.details = prize.details;
    prizeDTO.ordBy = prize.ordBy;
    prizeDTO.imageUrl = prize.imageUrl;
    if (!prize.startDate) {
        prize.startDate = new Date();
    }
    prizeDTO.startDate = DateUtils.dateToArray(prize.startDate);
    if (prize.endDate) {
        prizeDTO.endDate = DateUtils.dateToArray(prize.endDate);
    } else {
        prizeDTO.endDate = undefined;
    }
    return prizeDTO;   
}

export function getUserPrizeModel(userPrizeDTO: UserPrizeDTO): UserPrize {
    console.log("getting prize for userprize " + userPrizeDTO.id);
    const prize = getPrizeModel(userPrizeDTO.prize);
    const bookingDate: Date = DateUtils.arrayToDate(userPrizeDTO.bookingDate);
    const userPrize: UserPrize = new UserPrize(userPrizeDTO.id, prize, bookingDate);
    userPrize.redeemed = userPrizeDTO.redeemed;
    if (userPrizeDTO.collectionDate && userPrizeDTO.collectionDate.length > 0) {
        userPrize.collectionDate = DateUtils.arrayToDate(userPrizeDTO.collectionDate);
    }
    return userPrize;
}

export function getUserPrizeDTO(userPrize: UserPrize): UserPrizeDTO {
    const prizeDTO = getPrizeDTO(userPrize.prize);
    const bookingDate: Array<number> = DateUtils.dateToArray(userPrize.bookingDate);
    const userPrizeDTO: UserPrizeDTO = new UserPrizeDTO(userPrize.id, prizeDTO, bookingDate);
    userPrizeDTO.redeemed = userPrize.redeemed;
    if (userPrize.collectionDate) {
        userPrizeDTO.collectionDate = DateUtils.dateToArray(userPrize.collectionDate);
    }
    return userPrizeDTO;
}

export function getScoreModel(scoreDTO: ScoreDTO): Score {
    const score = new Score(scoreDTO.id, scoreDTO.points);
    score.description = scoreDTO.description;
    score.scoreDate = DateUtils.arrayToDate(scoreDTO.scoreDate);
    score.expirationDate = DateUtils.arrayToDate(scoreDTO.expireDate);
    score.expired = score.expirationDate < new Date();
    score.userCode = scoreDTO.userCode;
    score.deleted = scoreDTO.deleted;
    return score;   
}

export function getScoreDTO(score: Score): ScoreDTO {
    const scoreDTO = new ScoreDTO(score.id, score.points);
    scoreDTO.description = score.description;
    scoreDTO.userCode = score.userCode;
    if (score.scoreDate) {
        scoreDTO.scoreDate = DateUtils.dateToArray(score.scoreDate);
    }
    return scoreDTO;   
}
